// Angular
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
// Layout
import { LayoutConfigService, SplashScreenService } from '../../../core/_base/layout';
// Metronic
import { TranslationService } from '../../../core/_base/metronic';
// Auth
import { AuthNoticeService } from '../../../core/auth';
import { Meta } from '@angular/platform-browser';
import { CustomerService } from '../../../core/configuration/_services/customer.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'kt-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AuthComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('lottieContainer', { static: false }) lottieContainer: ElementRef;
	lottieLoaded = false;
	private lottieInstance: any;

	// Public properties
	today: number = Date.now();
	headerLogo: string;
	hostClient = location.host;
	isLogoAvailable: any = "";
	/** In a custom SaaS deployment the UptimeAI branding is hidden. */
	hideUptimeBranding = environment.runtime.CUSTOM_SAAS_DEPLOYMENT === true;
	layoutConfig: any;
	imagePaths = {
		uptimeAILogoWhite: 'assets/media/icons/svg/Auth/UptimeAI-logo-white.svg',
    	boxes: 'assets/media/icons/svg/Auth/boxes.svg',
	}


	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 * @param authNoticeService: authNoticeService
	 * @param translationService: TranslationService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(
		private readonly layoutConfigService: LayoutConfigService,
		public authNoticeService: AuthNoticeService,
		private readonly translationService: TranslationService,
		private readonly splashScreenService: SplashScreenService,
		private readonly customerService: CustomerService,
		private readonly meta: Meta ,
	    private readonly cdr:ChangeDetectorRef) {
		this.meta.removeTag('name="viewport"');
		this.meta.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=1' });
		this.layoutConfig = JSON.parse(localStorage.getItem('layoutConfig'));
		this.isLogoAvailable = this.layoutConfig['logo'] ? this.layoutConfig['logo'] : "";
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.translationService.setLanguage(this.translationService.getSelectedLanguage());
		this.headerLogo = this.layoutConfigService.getLogo();
		this.splashScreenService.hide();
		// Public info is loaded in main.ts before bootstrap, read from localStorage
		this.layoutConfig = JSON.parse(localStorage.getItem('layoutConfig')) || this.layoutConfig || {};
		this.isLogoAvailable = this.layoutConfig['logo'] || '';
	}

	ngAfterViewInit(): void {
		this.loadLottieScript()
			.then((lottie) => {
				if (this.lottieContainer && this.lottieContainer.nativeElement) {
					this.lottieInstance = lottie.loadAnimation({
						container: this.lottieContainer.nativeElement,
						renderer: 'svg',
						loop: true,
						autoplay: true,
						path: './assets/media/lottie/homepage-hero-general.json'
					});
					this.lottieLoaded = true;
					this.cdr.detectChanges();
				}
			})
			.catch((err) => {
				console.error('Failed to load lottie-web player library:', err);
			});
	}

	ngOnDestroy(): void {
		if (this.lottieInstance) {
			this.lottieInstance.destroy();
		}
	}

	private loadLottieScript(): Promise<any> {
		if ((window as any).lottie) {
			return Promise.resolve((window as any).lottie);
		}
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
			script.onload = () => resolve((window as any).lottie);
			script.onerror = (err) => reject(err);
			document.body.appendChild(script);
		});
	}
}
